import React, { forwardRef } from "react";
import accessibleDropdown from "./AccessibleDropdown";

const ExportReportList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      handleItemKeyDown,
      exportExcel,
      exportPdf,
      handleMenuItemClick,
      restrictHover,
      accessibilityValues,
      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
      },
      emailReport = () => {},
      exportAllExcel = () => {},
      children,
    },
    ref,
  ) => {
    const handleClick = ({ type }) => {
      if (type === "excel") {
        exportExcel();
      } else if (type === "pdf") {
        exportPdf();
      } else if (type === "allExcel") {
        exportAllExcel();
      } else if (type === "email") {
        emailReport();
        handleMenuItemClick(true, false);
      }
      handleMenuItemClick(false);
    };

    return (
      <div
        className={`popup_menu popup_menu_hover ${isOpen ? popupClassName.open : popupClassName.close}`}
      >
        <div
          className={`extract_data_container ${popupClassName.containerClass}`}
        >
          <p className="export_data_text">Export Data</p>

          <div
            id={accessibilityValues.ariaControls}
            role={accessibilityValues.ariaHaspopup}
            aria-label={accessibilityValues.ariaLabel}
            aria-labelledby={accessibilityValues.buttonId}
            ref={ref}
            className="listitem_container"
          >
            {menuItems.map(({ title, type, className }, index) => (
              <button
                aria-hidden={!isOpen}
                key={type}
                ref={(el) => (itemRefs.current[index] = el)}
                role="menuitem"
                onKeyDown={(e) => handleItemKeyDown(e, index)}
                className="list-data"
                onClick={() => handleClick({ type })}
              >
                <span className={className}></span>
                {title}
              </button>
            ))}
          </div>
          {children ? children : <></>}
        </div>
      </div>
    );
  },
);

export default accessibleDropdown(ExportReportList);
